import React from 'react';
import { Card, Avatar, Tag, Typography, Space } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { Client } from '../../types';
import { getTierColor, getStatusColor } from '../../utils/clientUtils';

const { Text } = Typography;

interface ClientCardProps {
  client: Client;
  onEdit?: (client: Client) => void;
  onViewDetails?: (client: Client) => void;
  showActions?: boolean;
}

const ClientCard: React.FC<ClientCardProps> = ({ 
  client, 
  onEdit, 
  onViewDetails, 
  showActions = true 
}) => {
  return (
    <Card
      size="small"
      hoverable={showActions}
      onClick={() => showActions && onViewDetails?.(client)}
      style={{ marginBottom: 8 }}
    >
      <Space align="start" style={{ width: '100%' }}>
        <Avatar icon={<UserOutlined />} size="large" />
        <div style={{ flex: 1 }}>
          <Text strong>{client.firstName} {client.lastName}</Text>
          <br />
          <Text type="secondary">{client.email}</Text>
          <br />
          <Space size="small">
            <Tag color={getTierColor(client.tier)}>{client.tier}</Tag>
            <Tag color={getStatusColor(client.status)}>{client.status}</Tag>
          </Space>
        </div>
      </Space>
    </Card>
  );
};

export default ClientCard; 